import { Pipe, PipeTransform } from '@angular/core';
import { DrugScheduleEnum } from '../../interfaces/DrugScheduleEnum ';
import { schedulesListWithCompound } from '../../interfaces/IScheduleFilter';

@Pipe({
  name: 'schedulesList',
})
export class SchedulesListPipe implements PipeTransform {
  /**
   *
   */
  constructor() {}

  transform(value: DrugScheduleEnum[]) {
    if (!value?.length) {
       return "";
    }
    
    const filtered = schedulesListWithCompound.filter(x => value.includes(x.id));
      return filtered
      ?.sort((a, b) => a.id - b.id)
      ?.map(x => x?.badgeAlias)
      ?.reduce((accumulator, currentValue) => accumulator + ', ' + currentValue);
  }
}  